import { IsNotEmpty, IsString, MinLength, MaxLength } from 'class-validator';

export class ProfileChangePasswordDTO {

    @IsNotEmpty()
    @IsString()
    @MinLength(8)
    @MaxLength(75)
    current: string;

    @IsNotEmpty()
    @IsString()
    @MinLength(8)
    @MaxLength(75)
    new: string;

    @IsNotEmpty()
    @IsString()
    @MinLength(8)
    @MaxLength(75)
    verify: string;

}
